module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "part01"
    }
  }), _c('a', {
    staticClass: "nounder1",
    attrs: {
      "href": "#/xhtml/contents"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART ONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "16",
      "src": "images/top.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2t"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Seven Ways to Peace and Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dale Carnegie wrote his book "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("How to Stop Worrying and Start Living")]), _vm._v(" to show that life is very much what we make it. If we first learn to accept ourselves, seeing the good as clearly as the not-so-good, and then get busy doing the things necessary to reach our goals, we will be less likely to have either the need or the inclination to lose time and energy worrying.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e32aa114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 78
// module chunks = 0